import { render, staticRenderFns } from "./OrderProdctExpand.vue?vue&type=template&id=104c4804&scoped=true&"
import script from "./OrderProdctExpand.vue?vue&type=script&lang=js&"
export * from "./OrderProdctExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104c4804",
  null
  
)

export default component.exports